module.exports = __webpack_public_path__ + "img/41.fa52384a.svg";